export default {
  en: {
    title: "Objectives",
    description:
      "Objectives are groups of goals (a.k.a. fact targets) that an adversary will try to accomplish on a campaing.",
    formTabNew: "New Objective",
    formTabCopy: "Copy an Objective",
    formNameLabel: "Objective Name",
    formNamePlaceholder: "Insert the name of the objective you want to create",
    formDescriptionLabel: "Objective Description",
    formDescriptionPlaceholder:
      "Describe the objective so you can easily identify it when looking for it.",
    formTargetLabel: "Target",
    formTargetPlaceholder: "Insert your target",
    formOperatorLabel: "Operator",
    formValueLabel: "Value",
    formValuePlaceholder: "Insert the value",
    formCountLabel: "Count",
    formCountPlaceholder: "0",
    formAchievedLabel: "Achieved",
    formAddGoalLabel: "Add Goal",
    formSelectExistingLabel: "Select an existing objective",
    formSelectExistingPlaceholder: "- None -",
    nameDefault: "Default"
  },
  pt: {
    title: "Objetivos",
    description:
      "Objetivos são grupos de metas (também conhecidos como fact targets) que o adversário tentará alcançar em uma campanha.",
    formTabNew: "Novo Objetivo",
    formTabCopy: "Copiar um Objetivo",
    formNameLabel: "Nome do objetivo",
    formNamePlaceholder: "Insira o nome do objetivo que você deseja criar",
    formDescriptionLabel: "Descrição do objetivo",
    formDescriptionPlaceholder:
      "Descreva o objetivo para que você possa identificá-lo facilmente ao procurá-lo.",
    formTargetLabel: "Alvo",
    formTargetPlaceholder: "Insira seu alvo",
    formOperatorLabel: "Operador",
    formValueLabel: "Valor",
    formValuePlaceholder: "Insira o valor",
    formCountLabel: "Contador",
    formCountPlaceholder: "0",
    formAchievedLabel: "Alcançado",
    formAddGoalLabel: "Adicionar Meta",
    formSelectExistingLabel: "Selecione um objetivo existente",
    formSelectExistingPlaceholder: "- Nenhum -",
    nameDefault: "Padrão"
  },
  es: {
    title: "Objetivos",
    description:
      "Los objetivos son grupos de metas (también conocidos como fact targets) que el adversario intentará alcanzar en una campaña.",
    formTabNew: "Nuevo objetivo",
    formTabCopy: "Copiar un objetivo",
    formNameLabel: "Nombre del objetivo",
    formNamePlaceholder: "Introduzca el nombre del objetivo que desea crear.",
    formDescriptionLabel: "Descripción del objetivo",
    formDescriptionPlaceholder:
      "Describa el objetivo para que pueda identificarlo fácilmente cuando lo busque.",
    formTargetLabel: "Target",
    formTargetPlaceholder: "Introduzca su target",
    formOperatorLabel: "Operador",
    formValueLabel: "Valor",
    formValuePlaceholder: "Introduzca el valor",
    formCountLabel: "Contador",
    formCountPlaceholder: "0",
    formAchievedLabel: "Alcanzado",
    formAddGoalLabel: "Añadir gol",
    formSelectExistingLabel: "Seleccione un objetivo existente",
    formSelectExistingPlaceholder: "- Ninguno -",
    nameDefault: "Standard"
  }
}
